import { useEffect, useState } from 'react'
import { PopupAction } from '../../../common/popup/PopupAction'
import { Notification } from '../../../common/notification'
import EventEmitter, {
  SHOW_POPUP_NO_INDUSTRY,
} from '../../../helpers/EventEmitter'

export const PopupNoIndustry = () => {
  const [isShow, setIsShow] = useState(false)

  useEffect(() => {
    const eventAction = () => {
      setIsShow(true)
    }

    EventEmitter.subscribe(SHOW_POPUP_NO_INDUSTRY, eventAction)
    return () => {
      EventEmitter.unsubscribe(SHOW_POPUP_NO_INDUSTRY, eventAction)
    }
  }, [])

  const handleClose = () => {
    setIsShow(false)
  }

  return (
    <PopupAction
      isShow={isShow}
      title={'industryOverview.NOTICE'}
      btnSubmit={{
        label: 'common.OK',
        isI18n: true,
        event: handleClose,
      }}
      handleClose={handleClose}
    >
      <Notification
        isI18n
        value="industryOverview.NOTICE_DESC"
        isItalic={false}
      />
    </PopupAction>
  )
}
